var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"m-3 p-2",attrs:{"label":_vm.label}},[_c('b-form-radio-group',{attrs:{"stacked":"","options":_vm.options},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }